import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CreateMarketingEventRequest,
  MarketingEvent,
  MarketingEventContentUpdateRequest,
  MarketingEventListItem,
  MarketingEventWorkloadUpdateRequest,
  UpdateMarketingEventRequest,
} from '@models/index';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class EventsService {
  private readonly url = `${environment.bffUrl}/events`;

  constructor(private http: HttpClient) {}

  getAll(status?: 'Active'): Observable<MarketingEventListItem[]> {
    const params = status ? { status } : undefined;
    return this.http.get<MarketingEventListItem[]>(this.url, { params });
  }

  getOne(id: string): Observable<MarketingEvent> {
    return this.http.get<MarketingEvent>(`${this.url}/${id}`);
  }

  add(event: CreateMarketingEventRequest): Observable<MarketingEvent> {
    return this.http.post<MarketingEvent>(this.url, event);
  }

  update(id: string, event: UpdateMarketingEventRequest): Observable<MarketingEvent> {
    return this.http.put<MarketingEvent>(`${this.url}/${id}`, event);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }

  setWorkloads(id: string, workloads: MarketingEventWorkloadUpdateRequest): Observable<MarketingEvent> {
    return this.http.post<MarketingEvent>(`${this.url}/${id}/set-workloads`, workloads);
  }

  activate(id: string): Observable<MarketingEvent> {
    return this.http.post<MarketingEvent>(`${this.url}/${id}/activate`, undefined);
  }

  deactivate(id: string): Observable<MarketingEvent> {
    return this.http.post<MarketingEvent>(`${this.url}/${id}/deactivate`, undefined);
  }

  setContent(id: string, content: MarketingEventContentUpdateRequest): Observable<MarketingEvent> {
    return this.http.post<MarketingEvent>(`${this.url}/${id}/content`, content);
  }

  addFieldExpert(eventId: string, fieldExpertId: string): Observable<MarketingEvent> {
    return this.http.post<MarketingEvent>(`${this.url}/${eventId}/field-experts`, { fieldExpertId });
  }

  deleteFieldExpert(eventId: string, fieldExpertId: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${eventId}/field-experts/${fieldExpertId}`);
  }
}
